import React, { FC } from 'react';

import { CircularProgress, CircularProgressProps } from '@material-ui/core';
import styled, { css } from 'styled-components';

export interface ILoaderProps extends CircularProgressProps {
  'data-testid'?: string;
  centered?: boolean;
}

const DEFAULT_TEST_ID = 'loader';
const DEFAULT_SIZE = 18;
const DEFAULT_THICKNESS = 5;

interface IStyledLoaderProps extends ILoaderProps {
  $centered?: boolean;
}
const StyledLoader = styled(CircularProgress)<IStyledLoaderProps>`
  ${({ $centered }) => css`
    left: 50%;
    top: 50%;
    position: ${() => ($centered ? 'absolute' : 'static')};
  `}
`;

export const Loader: FC<ILoaderProps> = ({
  'data-testid': testId = DEFAULT_TEST_ID,
  size = DEFAULT_SIZE,
  thickness = DEFAULT_THICKNESS,
  centered = false,
  ...rest
}) => <StyledLoader $centered={centered} data-testid={testId} size={size} thickness={thickness} {...rest} />;
